import * as Sentry from '@sentry/nextjs'

import { ENV_CONFIG } from './envConfig'

function beforeSend(event: Sentry.Event) {
  const exception = event.exception?.values?.[0]

  if (exception?.value.includes('Invariant: attempted to hard navigate to the same URL')) {
    return null
  }

  // Ignore errors from Turnstile captcha
  if (exception?.type === 'TurnstileError') {
    return null
  }

  if (exception?.type === 'AxiosError') {
    // Ignore low level network errors
    if (exception?.value.includes('Network Error')) {
      return null
    }

    // Ignore 403 and 401 errors
    if (exception?.value.includes('Request failed with status code 403')) {
      return null
    }

    if (exception?.value.includes('Request failed with status code 401')) {
      return null
    }
  }

  return event
}

const denyUrls = [
  /googletagmanager\.com/i,
  // Chrome extensions
  /extensions\//i,
  /^chrome:\/\//i,
]

const ignoreErrors = [
  // Random plugins/extensions
  'top.GLOBALS',
  'TabId is undefined',
  "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.",
]

export const defaultSentryOptions: Sentry.BrowserOptions | Sentry.NodeOptions | Sentry.EdgeOptions =
  {
    ignoreErrors,
    denyUrls,
    beforeSend,
    tracesSampleRate: 0.1,
    enabled: ENV_CONFIG.NODE_ENV == 'production',
    dsn: ENV_CONFIG.SENTRY_DSN,
    environment: ENV_CONFIG.NODE_ENV,
  }
